import { getEnumValues } from '../enums';

export enum TeamPermission{
	InviteAthlete='inviteAthlete',
}

export const TeamPermissionValues = getEnumValues<TeamPermission>(TeamPermission);